export default String.raw`
<div class="page-padding">
    {% assign mblist = '' -%}
    {% assign mbtype = '' -%}
    {% if page.PageId == config.DefinedPages.Manufacturers.Id -%}
        {% assign mblist = manufacturer-brand.Manufacturers -%}
        {% assign mbtype = 'manufacturer' -%}
    {% elsif page.PageId == config.DefinedPages.Brands.Id -%}
        {% assign mblist = manufacturer-brand.Brands -%}
        {% assign mbtype = 'brand' -%}
    {% endif -%}

    <div class="mblist-container">
        <div class="mblist-header">
            {% if mbtype == 'manufacturer' -%} 
                {{ translations.Manufacturers }} 
            {% elsif mbtype == 'brand' -%} 
                {{ translations.Brands }} 
            {% endif -%}
        </div>
        <div class="mblist-wrapper">
            {% assign counter = 0 %}
            {% for mb in mblist -%}
                {% assign counter = counter | Plus: 1 %}
                <a class="mblist-item manufacturer-js {% if counter > 12 %}hidden-js{% endif %}" href="{{ page.BaseHref }}{{ mb.Url }}">  
                    <div class="mblist-item--imgContainer">
                        {% if mb.Image != null -%}
                            {{ mb | Img:'small' }}
                        {% elsif mb.Image.ExternalUrl -%}
                            <img src="css/img/alo.gif" data-lazy="{{ mb.Image.ExternalUrl }}" alt="{{ mb.Name }}">
                        {% else -%}
                            <svg width="40" height="50">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
                            </svg>
                        {% endif -%}
                    </div>
                    <p class="mblist-item--name">{{ mb.Name }}</p>
                </a>
            {% endfor -%}
        </div>
        {% if mblist.size > 12 -%}
            <button class="pure-button show-more-manufacturers-js">{{ translations.ShowMore }}</button>
            <button class="pure-button show-less-manufacturers-js hidden-js">{{ translations.ShowLess }}</button>
        {% endif -%}
    </div>
</div>
`